import { Box, Typography } from '@mui/material';
import { MainCnt } from './style';
import TaskIcon from 'components/Icons/taskIcon';

const EmptyState = () => {
  return (
    <MainCnt alignItems="center" justifyContent="center" gap="5px">
      <Box className="imgCnt">
        <TaskIcon />
      </Box>
      <Typography className="title">No Request Forms Available</Typography>
      <Typography className="subTitle">
        No designated Request Forms have been set up yet.
      </Typography>
    </MainCnt>
  );
};

export default EmptyState;
